var map = {
	"./abstract-strategy": [
		"01b1",
		"services0"
	],
	"./camp-strategy": [
		"1457",
		"services1"
	],
	"./open-strategy": [
		"c8ce",
		"services2"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "61d8";
module.exports = webpackAsyncContext;